<template>
  <div id="app">
    <header>
      <div class="logoname">
        PT Infinity Information Technology
      </div>

      <nav>
        <a href="#sept_1">Beranda</a>
        <a href="#sept_2">Keunggulan</a>
        <a href="#sept_3">Produk</a>
        <a href="#sept_4">Hubungi Kami</a>
      </nav>
    </header>

    <div class="sept_1" id="sept_1">
      <div class="test-box">
        <p>PT Infinity Information Technology</p>
      </div>
    </div>

    <div class="sept_2" id="sept_2">
      <div class="sbtitle">Layanan yang Kami Sediakan</div>
      <div class="title">Kami menyediakan layanan terbaik untuk Anda</div>
      <div class="list-box">
        <div class="item item-1">
          <div class="text-box">
            <p>Layanan Pengembangan Perangkat Lunak</p>
            <div>Kami menyediakan layanan pengembangan perangkat lunak berkualitas tinggi dan dapat disesuaikan.</div>
          </div>
        </div>
        <div class="item item-2">
          <div class="text-box">
            <p>Pengembangan Aplikasi Seluler</p>
            <div>Kami mengembangkan aplikasi seluler inovatif untuk platform iOS dan Android.</div>
          </div>
        </div>
        <div class="item item-3">
          <div class="text-box">
            <p>Solusi Perangkat Lunak yang Dipesan</p>
            <div>Kami menyediakan solusi perangkat lunak yang dapat disesuaikan, dirancang dan dikembangkan sesuai dengan kebutuhan dan proses bisnis spesifik pelanggan.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="sept_3" id="sept_3">
      <div class="best-box">
        <p class="sbtitle">Produk yang Dipersonalisasi</p>
        <div class="title">Meditation Sound</div>
        <div class="text-box-1">Dengan suara putih yang menenangkan dan sesi meditasi yang dipandu, tenggelamlah dalam ketenangan. Santai, fokus, atau tidur lebih baik dengan suara yang kami kurasi dan latihan kesadaran. Unduh sekarang untuk mendapatkan kedamaian batin di mana pun Anda berada.</div>
        <a href="https://play.google.com/store/apps/details?id=com.meditation.rainsound">
          <img src="../assets/google-play.png" alt="">
        </a>
      </div>
      <img src="../assets/banner-5.png" alt="">
    </div>

    <div class="sept_8 sept_3" id="sept_8">
      <img src="../assets/ban_1.png" alt="">
      <div class="best-box">
        <!-- <p class="sbtitle">Produk yang Dipersonalisasi</p> -->
        <div class="title">BMI Calculator</div>
        <div class="text-box-1">
          BMI Calculator is a practical health tool that helps you quickly understand your body fat percentage. Just enter your height, weight, age and gender, and the calculator will use a professional formula to calculate your body fat percentage, which reflects your physical health and has important reference value for preventing cardiovascular disease and diabetes.
          <br>
          This calculator uses authoritative methods, the results are accurate and reliable, the operation is simple, and no registration is required. It is suitable for busy modern people to check at any time. Regularly measuring body fat percentage can help adjust diet and exercise to maintain a healthy level.
          <br>
          Please note that the measurement results are affected by many factors. It is recommended to be carried out under professional guidance to obtain more accurate data. In short, this calculator helps you understand your physical condition, adjust your lifestyle, and maintain a healthy body fat percentage. It is recommended for everyone to use!
        </div>
        <a href="https://play.google.com/store/apps/details?id=com.fat.fatbimcalculator">
          <img src="../assets/google-play.png" alt="">
        </a>
      </div>

    </div>

    <div class="sept_9 sept_3" id="sept_8">

      <div class="best-box">
        <!-- <p class="sbtitle">Produk yang Dipersonalisasi</p> -->
        <div class="title">Healthy Life Plus </div>
        <div class="text-box-1">
          Healthy Life Plus is a convenient app that helps you develop good living habits. By setting goals such as drinking water and going to bed early, it will remind you to complete them on time and establish a healthy lifestyle.
          <br>
          The interface is simple, and users can easily set goals and check in. The reminder function helps you overcome procrastination, and continuous check-ins allow you to clearly see your progress and increase motivation. The app also provides data statistics to help you understand your living habits and adjust your goals.
          <br>
          Developing good habits requires self-awareness and persistence, maintaining a positive attitude, and believing that you can change. In short, Healthy Life Plus is a practical tool that improves the quality of life and is worth recommending!

        </div>
        <a href="https://play.google.com/store/apps/details?id=com.lifeplus.healthy">
          <img src="../assets/google-play.png" alt="">
        </a>
      </div>
      <img src="../assets/ban_2.png" alt="">
    </div>

    <div class="sept_4" id="sept_4">
      <div class="sbtitle">Nilai Kami</div>
      <div class="title">Kami terus menjelajahi teknologi dan metode baru</div>
      <div class="list-box">
        <img src="../assets/banner-6.png" alt="">
        <img src="../assets/banner-7.png" alt="">
        <img src="../assets/banner-8.png" alt="">
      </div>
    </div>

    <div class="sept_5" id="sept_5">
      <img src="../assets/banner-9.png" alt="">
      <div class="inpu-box">
        <p class="sbtitle">Selamat datang</p>
        <div class="title">Hubungi Kami</div>
        <div class="input-box">
          <input class="input-text" type="text" placeholder="Nama">
          <input class="input-text" type="text" placeholder="Alamat Email">
        </div>
        <div class="input-box">
          <input class="input-text" type="text" placeholder="Alamat">
          <input class="input-text" type="text" placeholder="Telepon">
        </div>
        <div class="input-box">
          <textarea class="input-text textarea-text" name="" id="" cols="30" rows="10" placeholder="Pesan"></textarea>
        </div>
        <div class="btn-send">Kirim</div>
      </div>

    </div>

    <div class="sept_6" id="sept_6">
      <div class="sbtitle">Tim Kami</div>
      <div class="title">Layanan Tim yang Profesional</div>
      <div class="list-box">
        <img src="../assets/banner-10.png" alt="">
        <img src="../assets/banner-11.png" alt="">
        <img src="../assets/banner-12.png" alt="">
      </div>
    </div>

    <div class="sept_7" id="sept_7">
      <div class="text-box">
        <div class="sbtitle">Tim Kami</div>
        <div class="title">Layanan Tim yang Profesional</div>
        <div class="text">
          Anggota tim kami berasal dari latar belakang dan bidang yang beragam, termasuk pengembangan perangkat lunak, teknologi informasi, analisis data, kecerdasan buatan, dan lain-lain. Mereka memiliki pengalaman yang kaya dan dapat dengan fleksibel menghadapi berbagai tantangan, serta memberikan solusi inovatif.
        </div>
      </div>
      <img src="../assets/banner-13.png" alt="">
    </div>


    <footer id="contact">
      <div class="footer-box">
        <div class="contact">
          <p>
            PT Infinity Information Technology
          </p>
          <p>
            Gedung Grand Slipi Lantai 9 Jl. Letjen S. Parman Kav. 22-24, Kel. Palmerah, Kec. Pal Merah, Kota Adm. Jakarta Barat, Prop. DKI JakartaN
          </p>
        </div>
      </div>


    </footer>
    <p class="end">
      Copyright © 2024. All rights reserved.
    </p>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      showDownload: false
    }
  },
  created() {
    if (this.$route.query.show == 1) {
      this.showDownload = true
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("sept_1").scrollIntoView(); break;
        case 1: document.getElementById("sept_2").scrollIntoView(); break;
        case 2: document.getElementById("sept_3").scrollIntoView(); break;
        case 3: document.getElementById("sept_4").scrollIntoView(); break;
        case 4: document.getElementById("sept_5").scrollIntoView(); break;
        case 5: document.getElementById("sept_6").scrollIntoView(); break;
        case 6: document.getElementById("sept_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    goPage() {
      this.$router.push({
        path: '/privacy'
      })
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
